import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios';
import router from '@/router'

let url = 'https://sitebypro-server.ru/druzbamebel'

const LOCAL_CART_KEY = 'druzhba_guest_cart_v1'
const GUEST_HASH_KEY = 'druzhba_guest_hash_v1'
const GUEST_CONTACT_KEY = 'druzhba_guest_contact_v1'
const ATTRIBUTION_KEY = 'druzhba_analytics_attribution_v1'

function safeJsonRead(key, fallback) {
  try { return JSON.parse(window.localStorage.getItem(key) || '') } catch (_) { return fallback }
}
function persistLocalCart(cart) {
  try { window.localStorage.setItem(LOCAL_CART_KEY, JSON.stringify(Array.isArray(cart) ? cart : [])) } catch (_) {}
}
function readLocalCart() {
  const value = safeJsonRead(LOCAL_CART_KEY, [])
  return Array.isArray(value) ? value : []
}
function guestHash() {
  try {
    let value = String(window.localStorage.getItem(GUEST_HASH_KEY) || '')
    if (!value) {
      const suffix = window.crypto && typeof window.crypto.randomUUID === 'function' ? window.crypto.randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`
      value = `guest-${suffix}`
      window.localStorage.setItem(GUEST_HASH_KEY, value)
    }
    return value
  } catch (_) { return `guest-${Date.now()}-${Math.random().toString(16).slice(2)}` }
}
function guestContact() { return safeJsonRead(GUEST_CONTACT_KEY, {}) || {} }
function attribution() {
  const base = safeJsonRead(ATTRIBUTION_KEY, {}) || {}
  try {
    const query = new URL(window.location.href).searchParams
    return {
      ...base,
      yclid: String(query.get('yclid') || base.yclid || window.localStorage.getItem('druzhba_yclid') || ''),
      vk_click_id: String(query.get('vk_click_id') || query.get('vk_click') || base.vk_click_id || '')
    }
  } catch (_) { return base }
}

function filteredCart (cart) {
  let items = cart
  const result = items.reduce((acc, item) => {
      const key = `${item.id}-${item.choosen_color && (item.choosen_color.id || item.choosen_color.color) ? (item.choosen_color.id || item.choosen_color.color) : 'default'}`;

      if (!acc[key]) {
          acc[key] = { ...item, count: 1 };
      } else {
          acc[key].count += 1;
      }

      return acc;
  }, {})

  const finalResult = Object.values(result)

  return finalResult
}

function isShippingQuoteRefreshError (message) {
  const value = String(message || '').toLowerCase()
  return value.includes('стоимость доставки устарела') ||
    value.includes('расчёт доставки истёк') ||
    value.includes('расчет доставки истек') ||
    value.includes('изменились адрес/корзина') ||
    value.includes('выполните расчёт ещё раз') ||
    value.includes('выполните расчет еще раз')
}

export default {
  state: {
    user: {
    },
    cart: readLocalCart(),
    updateTimeout: null,
    orders: [],
    authFeedback: '',
  },
  getters: {
    user (state) {
      return state.user
    },
    cart (state) {
      return state.cart
    },
    orders (state) {
      return state.orders
    },
    authFeedback (state) {
      return state.authFeedback
    }
  },
  mutations: {
    ADD_USER_ADDRESSES (state, data) {
      let useraddresses = [...state.user.addresses]
      useraddresses.push(data.address)
      state.user.addresses = useraddresses
    },
    DELETE_USER_ADDRESSES (state, data) {
      let useraddresses = [...state.user.addresses]
      useraddresses = useraddresses.filter(item => item.id !== data.address.id);
      state.user.addresses = useraddresses
    },
    CHANGE_USER_ADDRESSES (state, data) {
      let useraddresses = [...state.user.addresses]
      useraddresses = useraddresses.map(item =>
        item.id === data.address.id ? { ...data.address } : item
      );
      state.user.addresses = useraddresses
    },
    SET_USER (state, data) {
      window.localStorage.setItem('user_hash', data.hash)
      window.localStorage.setItem('email', data.email)
      state.user = data
    },
    CLEAR_USER (state) {
      window.localStorage.removeItem('user_hash')
      window.localStorage.removeItem('email')
      state.user = {}
      state.orders = []
    },
    SET_ORDERS (state, data) {
      state.orders = data
    },
    SET_AUTH_FEEDBACK (state, message) {
      state.authFeedback = String(message || '')
    },
    PUSH_TO_CART (state, data) {
      state.cart.push(data)
      persistLocalCart(state.cart)
    },
    DELETE_FROM_CART (state, data) {
      let copy = [...state.cart];

      let ind = copy.findIndex(obj => obj.id === data.id && obj.choosen_color === data.choosen_color);

      if (ind !== -1) {
        copy.splice(ind, 1);
      } else {
        ind = copy.findIndex(obj => obj.id === data.id);
        copy.splice(ind, 1);
      }

      state.cart = copy;
      persistLocalCart(state.cart)
    },
    CLEAR_CART (state, data) {
      state.cart = []
      persistLocalCart(state.cart)
    },
    DELETE_GROUP_FROM_CART (state, data) {
      let withoutGroup = [...state.cart].filter((item) => !(item.id == data.id && item.choosen_color.color == data.choosen_color.color))
      state.cart = withoutGroup
      persistLocalCart(state.cart)
    },
    CHANGE_COLOR (state, data) {
      let copy = [...state.cart]
      copy.reduce((accumulator, item)=>{
        if(item.id == data.equipment.id && item.choosen_color == data.equipment.choosen_color) {
          item.choosen_color = data.pattern
        }
        accumulator.push(item)
        return accumulator
      }, [])
      state.cart = copy
      persistLocalCart(state.cart)
    },
    SET_CART (state, data) {
      if(!state.user.cart) return
      let cart = [...state.user.cart].reduce((accumulator, item)=>{
        let equipment = {}
        equipment = [...data].find((eq) => eq.id == item.equipment_id)
        equipment.choosen_color = equipment.pattern_list.find((pattern) => pattern.id == item.choosen_color_id)
        let uniq_equipments = new Array(item.count).fill({...equipment})
        accumulator = accumulator.concat(uniq_equipments)
        return accumulator
      }, [])
      state.cart = cart
      persistLocalCart(state.cart)
    },
    UPDATE_USER (state, data) {
      console.log(data, 'zxc')
      state.user = {...data}
    }
  },
  actions: {
    async GET_ORDERS ({dispatch, commit, state}, data) {
      await axios({
        method: 'post',
        url: url + '/user/get-orders',
        data: {'hash': data.hash}
      }).then((res)=>{
        let result = res.data
        if(result.status == 200)
          commit('SET_ORDERS', result.data)
        else
          console.log('Пользователь не найден')
      })

    },
    async CREATE_ORDER ({ dispatch, commit, state }, data) {
      commit('SET_CHECKOUT_LOADING', true)

      try {
        const filteredCartList = filteredCart([...state.cart])
        const cart = filteredCartList.map((item) => ({
          equipment_id: item.id,
          count: item.count,
          choosen_color_id: item.choosen_color && item.choosen_color.id
            ? item.choosen_color.id
            : null
        }))

        const record = {
          hash: state.user.hash || guestHash(),
          cart,
          payment_method: data.payment_method,
          choosen_address: data.choosen_address,
          choosen_delivery_type: data.choosen_delivery_type || data.delivery_type,
          shipping_quote_token: data.shipping_quote_token || null,
          checkout_token: data.checkout_token,
          legal: data.legal || null,
          contact: state.user.hash ? { name: state.user.FIO || '', phone: state.user.phone || '', email: state.user.email || '' } : guestContact(),
          attribution: attribution()
        }

        const response = await axios.post(url + '/payments/checkout', record, { timeout: 70000 })
        const result = response && response.data ? response.data : {}
        const payload = result.data || {}

        if (String(result.status) !== '200') {
          throw new Error(payload.text || 'Не удалось оформить заказ')
        }

        if (payload.payment_required && payload.confirmation_url) {
          window.location.assign(payload.confirmation_url)
          return payload
        }

        await dispatch('CLEAR_CART')
        await router.push({ path: '/cart', query: { success: 'true', order: payload.order_id || '' } })
        return payload
      } catch (error) {
        const payload = error && error.response && error.response.data && error.response.data.data
          ? error.response.data.data
          : {}
        const message = payload.text || error.message || 'Не удалось оформить заказ'
        if (isShippingQuoteRefreshError(message)) {
          return { checkout_error: 'shipping_quote_refresh_required', message }
        }
        commit('SET_ALERT', { type: 1, message })
        return false
      } finally {
        commit('SET_CHECKOUT_LOADING', false)
      }
    },
    async GET_CART ({dispatch, commit}, data) {

      commit('SET_CART', data)
    },
    async UPDATE_CART ({dispatch, commit, state}) {
      persistLocalCart(state.cart)
      if (!state.user || !state.user.hash) return true
      //обновляем в sql
      clearTimeout(state.updateTimeout)
      state.updateTimeout = setTimeout(async ()=>{
        let filteredCartList = filteredCart([...state.cart])

        let cart = filteredCartList.reduce((accamulate, item)=>{
          let equipment = {
            equipment_id: item.id,
            count: item.count,
            choosen_color_id: item.choosen_color && item.choosen_color.id ? item.choosen_color.id : null
          }
          accamulate.push(equipment)

          return accamulate
        }, [])
        let record = {
          hash: state.user.hash || guestHash(),
          cart: cart
        }

        await axios({
          method: 'post',
          url: url + '/user/update-cart',
          data: record
        }).then((res)=>{
          let result = res.data
          console.log(result)
        })
      }, 2000)
    },
    CHANGE_COLOR ({dispatch, commit}, data) {
      commit('CHANGE_COLOR', data)

      dispatch('UPDATE_CART')
    },
    CLEAR_CART ({dispatch, commit}) {
      commit('CLEAR_CART')

      dispatch('UPDATE_CART')
    },
    async ADD_TO_CART ({dispatch, commit}, data) {
      let ui_data = {...data}
      if(!data.hasOwnProperty('choosen_color')) {
        ui_data.choosen_color = Array.isArray(ui_data.pattern_list) && ui_data.pattern_list.length ? ui_data.pattern_list[0] : null
      }
      commit('PUSH_TO_CART', ui_data)

      dispatch('UPDATE_CART')
    },
    async DELETE_FROM_CART ({dispatch, commit}, data) {
      commit('DELETE_FROM_CART', data)

      dispatch('UPDATE_CART')
    },
    async DELETE_GROUP_FROM_CART ({dispatch, commit}, data) {
      commit('DELETE_GROUP_FROM_CART', data)

      dispatch('UPDATE_CART')
    },
    async UPDATE_USER({dispatch, commit}, data) {
      await axios({
        method: 'post',
        url: url + '/user/update-user',
        data: data
      }).then((res)=>{
        let result = res.data
        commit('UPDATE_USER', data)
      })
    },
    async LOGIN_USER({ commit }, data) {
      commit('SET_AUTH_FEEDBACK', '')
      try {
        const res = await axios({ method: 'post', url: url + '/user/get-user', data })
        const result = res.data || {}
        if (String(result.status) !== '200') {
          const message = result && result.data && result.data.text
            ? result.data.text
            : 'Пользователь с такой почтой или паролем не найден'
          commit('SET_AUTH_FEEDBACK', message)
          commit('SET_ALERT', { type: 1, message })
          return false
        }
        commit('SET_USER', result.data)
        return true
      } catch (error) {
        const message = 'Не удалось выполнить вход. Попробуйте ещё раз'
        commit('SET_AUTH_FEEDBACK', message)
        commit('SET_ALERT', { type: 1, message })
        return false
      }
    },
    async RELOG_USER({dispatch, commit}, data) {
      try {
        const res = await axios({ method: 'post', url: url + '/user/relog-user', data })
        const result = res.data
        if (String(result.status) !== '200') {
          window.localStorage.removeItem('email')
          window.localStorage.removeItem('user_hash')
          return false
        }
        commit('SET_USER', result.data)
        dispatch('GET_ORDERS', result.data)
        return true
      } catch (error) {
        window.localStorage.removeItem('email')
        window.localStorage.removeItem('user_hash')
        return false
      }
    },
    async REGISTER_USER({ commit }, data) {
      commit('SET_AUTH_FEEDBACK', '')
      try {
        const res = await axios({ method: 'post', url: url + '/user/add-user', data })
        const result = res.data || {}
        const payload = result.data || {}
        const status = String(result.status || '')

        if (status === '200' && payload.account_created) {
          const message = payload.text || 'Письмо для подтверждения отправлено.'
          commit('SET_AUTH_FEEDBACK', message)
          commit('SET_ALERT', { type: 1, message })
          return { accountCreated: true, emailSent: Boolean(payload.email_sent), message }
        }

        if (status === '400' && payload.account_created) {
          const message = payload.text || 'Аккаунт создан, но письмо не удалось отправить.'
          commit('SET_AUTH_FEEDBACK', message)
          commit('SET_ALERT', { type: 1, message })
          return { accountCreated: true, emailSent: false, message }
        }

        if (status === '409' && payload.email_pending) {
          const message = payload.text || 'Аккаунт уже создан, но почта ещё не подтверждена.'
          commit('SET_AUTH_FEEDBACK', message)
          commit('SET_ALERT', { type: 1, message })
          return { accountCreated: true, emailSent: false, message }
        }

        const message = payload.text || 'Не удалось создать аккаунт. Проверьте введённые данные.'
        commit('SET_AUTH_FEEDBACK', message)
        commit('SET_ALERT', { type: 1, message })
        return { accountCreated: false, emailSent: false, message }
      } catch (error) {
        const payload = error && error.response && error.response.data ? error.response.data.data || {} : {}
        const message = payload.text || 'Не удалось создать аккаунт. Попробуйте ещё раз'
        commit('SET_AUTH_FEEDBACK', message)
        commit('SET_ALERT', { type: 1, message })
        return { accountCreated: false, emailSent: false, message }
      }
    },
    async RESEND_VERIFICATION({ commit }, data) {
      commit('SET_AUTH_FEEDBACK', '')
      try {
        const res = await axios({ method: 'post', url: url + '/user/resend-verification', data })
        const result = res.data || {}
        const payload = result.data || {}
        const message = payload.text || (String(result.status) === '200' ? 'Письмо отправлено.' : 'Не удалось отправить письмо.')
        commit('SET_AUTH_FEEDBACK', message)
        commit('SET_ALERT', { type: 1, message })
        return { emailSent: String(result.status) === '200' && Boolean(payload.email_sent), retryAfter: Number(payload.retry_after || 0), message }
      } catch (error) {
        const payload = error && error.response && error.response.data ? error.response.data.data || {} : {}
        const message = payload.text || 'Не удалось отправить письмо. Попробуйте ещё раз позже.'
        commit('SET_AUTH_FEEDBACK', message)
        commit('SET_ALERT', { type: 1, message })
        return { emailSent: false, retryAfter: Number(payload.retry_after || 0), message }
      }
    },
    async SUBMIT_USER({ commit }, data) {
      commit('SET_AUTH_FEEDBACK', '')
      try {
        const res = await axios({ method: 'post', url: url + '/user/submit-user', data })
        const result = res.data || {}
        if (String(result.status) !== '200' || !result.data || !result.data.email) {
          const message = result && result.data && result.data.text ? result.data.text : 'Не удалось подтвердить электронную почту.'
          commit('SET_AUTH_FEEDBACK', message)
          commit('SET_ALERT', { type: 1, message })
          return false
        }
        commit('SET_USER', result.data)
        commit('SET_ALERT', { type: 1, message: 'Электронная почта подтверждена' })
        return true
      } catch (error) {
        const message = 'Не удалось подтвердить электронную почту. Откройте ссылку ещё раз.'
        commit('SET_AUTH_FEEDBACK', message)
        commit('SET_ALERT', { type: 1, message })
        return false
      }
    },

    async REQUEST_PASSWORD_RESET({ commit }, data) {
      commit('SET_AUTH_FEEDBACK', '')
      try {
        const res = await axios({
          method: 'post',
          url: url + '/user/request-password-reset',
          data: { email: String(data && data.email || '').trim() }
        })
        const result = res.data || {}
        const payload = result.data || {}
        const message = payload.text || 'Если аккаунт с такой почтой существует, письмо уже отправлено.'
        const ok = String(result.status) === '200'
        commit('SET_AUTH_FEEDBACK', message)
        return {
          ok,
          message,
          retryAfter: Number(payload.retry_after || 0)
        }
      } catch (error) {
        const payload = error && error.response && error.response.data
          ? error.response.data.data || {}
          : {}
        const message = payload.text || 'Не удалось отправить письмо. Попробуйте ещё раз позже.'
        commit('SET_AUTH_FEEDBACK', message)
        return {
          ok: false,
          message,
          retryAfter: Number(payload.retry_after || 0)
        }
      }
    },
    async VALIDATE_PASSWORD_RESET({ commit }, data) {
      commit('SET_AUTH_FEEDBACK', '')
      try {
        const res = await axios({
          method: 'post',
          url: url + '/user/validate-password-reset',
          data: { token: String(data && data.token || '').trim() }
        })
        const result = res.data || {}
        const payload = result.data || {}
        const valid = String(result.status) === '200' && Boolean(payload.valid)
        const message = payload.text || (valid ? '' : 'Ссылка недействительна или уже истекла.')
        commit('SET_AUTH_FEEDBACK', message)
        return { valid, message }
      } catch (error) {
        const payload = error && error.response && error.response.data
          ? error.response.data.data || {}
          : {}
        const message = payload.text || 'Ссылка недействительна или уже истекла.'
        commit('SET_AUTH_FEEDBACK', message)
        return { valid: false, message }
      }
    },
    async RESET_PASSWORD({ commit }, data) {
      commit('SET_AUTH_FEEDBACK', '')
      try {
        const res = await axios({
          method: 'post',
          url: url + '/user/reset-password',
          data: {
            token: String(data && data.token || '').trim(),
            password: String(data && data.password || ''),
            passwordConfirm: String(data && data.passwordConfirm || '')
          }
        })
        const result = res.data || {}
        const payload = result.data || {}
        const ok = String(result.status) === '200' && Boolean(payload.password_reset)
        const message = payload.text || (ok ? 'Пароль изменён.' : 'Не удалось изменить пароль.')
        if (ok) commit('CLEAR_USER')
        commit('SET_AUTH_FEEDBACK', message)
        return { ok, message }
      } catch (error) {
        const payload = error && error.response && error.response.data
          ? error.response.data.data || {}
          : {}
        const message = payload.text || 'Не удалось изменить пароль. Получите новую ссылку.'
        commit('SET_AUTH_FEEDBACK', message)
        return { ok: false, message }
      }
    },
    async SEND_REQUEST({dispatch, commit}, data) {
      const response = await axios({
        method: 'post',
        url: url + '/user/work-reguest',
        data: data,
        timeout: 20000
      })
      const result = response && response.data ? response.data : {}
      const payload = result.data || {}
      if (String(result.status) !== '200' && String(result.status) !== '0') {
        throw new Error(payload.text || 'Не удалось отправить заявку.')
      }
      return payload
    }
  },

}



